import { ChangeDetectionStrategy, Component, OnInit, input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog'
import { ReportService } from 'src/app/services/report.service';
import { UserService } from 'src/app/services/user.service';
import { DialogService } from 'src/app/services/dialog.service';
import { ConfirmationToastComponent } from 'src/app/components/confirmation-toast/confirmation-toast.component';

@Component({
  selector: 'app-view-regional-officer',
  templateUrl: './view-regional-officer.component.html',
  styleUrls: ['./view-regional-officer.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})


export class ViewRegionalOfficerComponent implements OnInit {

  regionContacts: any[] = [];
  report = input.required<any>();

  constructor(
    public dialog: MatDialog,
    public readonly reportService: ReportService,
    public readonly userService: UserService,
    public readonly dialogService: DialogService,
    public readonly toast: ConfirmationToastComponent,
  ) { }

  ngOnInit(): void {
    this.loadUsers();
  }

  loadUsers() {
    let roSign = this.report().signatures?.filter((signature: any) => signature.signature_type_id == 1);
    roSign.forEach((ro: any) => {
      if (ro.user_id)
        this.userService.getUser(ro.user_id).subscribe((user: any) => {
          // 16-Regional Line Officer
          // 17-Acting Regional Line Officer
          user.users[0].isROLO = user.users[0].baer_roles.filter((obj: any) => [16, 17].includes(obj.baer_role.value));
          this.regionContacts.push(user.users[0]);
        })
    })
  }
}
